<template>
  <div>
    <v-card class="ma-6 pa-6 pb-0" outlined>
      <AbsentChartFilter @onFilterChanged="refresh" />
    </v-card>
    <v-card class="ma-6" outlined>
      <AbsentChart ref="diligence-data-table" :filters="filters" />
    </v-card>
  </div>
</template>

<script>
import AbsentChartFilter from './components/AbsentChartFilter.vue'
import AbsentChart from './components/AbsentChart.vue'

export default {
  components: {
    AbsentChart,
    AbsentChartFilter
  },
  data() {
    return {
      action: {
        state: 'select'
      },
      filters: null,
      currClass: null
    }
  },
  methods: {
    refresh(query) {
      this.filters = query
      this.$nextTick(() => {
        this.$refs['diligence-data-table'].searchStudentDiligences()
      })
    }
  }
}
</script>
